import { ComponentAdapter } from "@omegagrid/core";
import { TreeAdapter } from "@omegagrid/tree";
import { Parameter } from "@reporting/rp-types/etl";

export abstract class SqlParameterListAdapter extends ComponentAdapter {

	abstract getParentId(): number|string;

	abstract getParameters(): Parameter[]|Promise<Parameter[]>;

	abstract delete(parameter: Parameter): void|Promise<void>;

	abstract getTreeAdapter(parameter: Parameter): TreeAdapter;

	abstract createComponentId(type: 'form'|'contentEditor'|'valueEditor', parameter?: Parameter): string;

	abstract isReadonly(): boolean;

}
